import { render, staticRenderFns } from "./EmailSuppressionChip.vue?vue&type=template&id=8d3c1322&"
import script from "./EmailSuppressionChip.vue?vue&type=script&lang=js&"
export * from "./EmailSuppressionChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports